<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <basin-textbox-with-units
    [min]="props.min"
    [max]="props.max"
    [numberType]="props.numberType"
    [prepend]="props.prepend ?? ''"
    [append]="props.append ?? ''"
    autocomplete="off"
    class="{{ !!formControl.value ? 'p-filled' : '' }}"
    [id]="field.id"
    [defaultValue]="props.defaultValue"
    [name]="field.id"
    [placeholder]="props.placeholder"
    [minlength]="props.minlength"
    [maxlength]="props.maxlength"
    [readonly]="props.readonly"
    [required]="props.required"
    [formControl]="formControl"
    [formlyAttributes]="field"
    (keyup.enter)="props.onEnter ? props.onEnter(field, $event) : ''"
  ></basin-textbox-with-units>
</span>
